import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import check from "../../assets/images/check.svg";
import {
  closeRegisterSuccessPrompt,
  openMobileOtpModal,
  resetCountdown,
} from "../../features/slices/ModalSlice";
import { updateSelectedItem } from "../../features/slices/CommonSlice";
import { sendRegisterPhoneOtp } from "../../features/slices/UserSlice";
import { selectRegistrationAuth } from "../../features/slices/AppConfigSlice";
import { formatRegisterPhone } from "../../utils/buildRegisterPayload";

export default function RegisterSuccessPrompt() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const phoneDetails = useSelector((state) => state.user.phoneDetails);
  const registrationAuth = useSelector(selectRegistrationAuth);
  const [error, setError] = useState("");
  const [isSending, setIsSending] = useState(false);

  const closePrompt = () => {
    dispatch(closeRegisterSuccessPrompt());
  };

  const handleOkay = () => {
    const { countryCode, phone } = phoneDetails || {};
    const fullPhone = formatRegisterPhone(countryCode, phone);

    if (!fullPhone) {
      setError("A valid phone number is required for verification");
      return;
    }

    setError("");
    setIsSending(true);

    dispatch(
      sendRegisterPhoneOtp({
        phone: fullPhone,
        action: "register",
        delivery_method: registrationAuth?.default_delivery_method || "sms",
      })
    )
      .unwrap()
      .then(() => {
        dispatch(closeRegisterSuccessPrompt());
        dispatch(resetCountdown());
        if (isMobile) {
          dispatch(updateSelectedItem("mobileOTP"));
        } else {
          dispatch(openMobileOtpModal());
        }
      })
      .catch((err) => {
        setError(
          err?.error || err?.message || "Failed to send OTP. Please try again."
        );
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <div
      className="modal fade otp--modal mpin-setup-prompt show"
      style={{
        display: "block",
        backdropFilter: "blur(15px)",
        background: "rgb(70, 70, 70, 0.6)",
      }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h2 className="modal-title fs-5" />
            <i
              data-bs-dismiss="modal"
              aria-label="Close"
              className="bi bi-x-lg"
              onClick={closePrompt}
            />
          </div>
          <div className="modal-body mpin-setup-prompt__body text-center">
            <img
              loading="lazy"
              src={check}
              alt="Registration successful"
              width={72}
              height={72}
            />
            <p className="mpin-setup-prompt__subtitle">
              Registration Successful!
            </p>
            <p className="mpin-setup-prompt__title">
              Please move forward to verify your number
            </p>
            {error && <p className="message mb-3">{error}</p>}
            <div className="mpin-setup-prompt__actions">
              <button
                type="button"
                className="mpin-setup-prompt__yes-btn"
                onClick={handleOkay}
                disabled={isSending}
              >
                {isSending ? "Sending OTP..." : "Okay"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
